/* eslint-disable react/no-danger */
import React from 'react';
import { isEmpty, map } from 'lodash';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';
import Sprites from '../components/Sprites';

export default function FreeZoneDWTCAuthority({ id, data }) {
  const {
    title,
    text,
    newCompanyTitle,
    newCompanyText,
    newCompanyItems,
    existingCompanyTitle,
    existingCompanyText,
    existingCompanyItems,
    backgroundImage,
  } = data;
  return (
    <section id={id} className="bg-[#F7F7F7] relative overflow-hidden">
      <BoxedContainer className="z-10">
        <div
          className="pt-[50px] lg:pt-[100px] pb-[170px] md:pb-[140px] lg:pb-[170px] flex flex-col
        gap-y-10 lg:gap-y-20">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col gap-y-5 lg:gap-y-[30px] max-w-[1024px] mx-auto">
            <div className="flex flex-col gap-y-5">
              <div
                dangerouslySetInnerHTML={{ __html: title }}
                className="text-clamp20to40  h2-child:text-clamp20to40 text-[#231F20]
              h2-child:leading-1.2 text-center h2-child:m-0"
              />
              <div className="h-[2px] w-[70px] bg-[#CE445B] mx-auto" />
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: text }}
              className="p-child:text-[#4D4D4D] p-child:text-clamp12to18 p-child:font-normal
              p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular p-child:rtl:font-GESSTwoDWTCLight
              text-center"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col lg:flex-row gap-10 md:gap-6 2l:gap-[30px]">
            <div
              className="flex flex-col gap-y-[13px] lg:gap-y-[30px] lg:max-w-[570px]
            lg:items-center">
              <div
                className="flex flex-row lg:flex-col gap-x-[15px] md:gap-y-[30px]
              lg:items-center">
                <Sprites name="new-company" className="w-[20px] lg:w-[55px] h-[20px] lg:h-[55px] relative top-[-4px] lg:top-0" />
                <div className="flex flex-row gap-x-[15px]">
                  <Sprites name="left-down-arrow" className="mt-[9px] hidden lg:flex rtl:scale-x-[-1]" />
                  <span
                    className="text-clamp16to20 text-[#231F20] 
                    ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1 
                    rtl:pt-[2px] rtl:md:pt-0 
                    text-center">
                    {newCompanyTitle}
                  </span>
                  <Sprites name="right-arrow-down" className="mt-[9px] hidden lg:flex rtl:scale-x-[-1]" />
                </div>
              </div>
              <p
                className="!m-0 text-clamp12to18 text-[#4D4D4D] leading-1.375 ltr:text-left
                rtl:text-right lg:!text-center font-DINRegular
                lg:min-h-[65px] xl:min-h-[70px] 2xl:min-h-[75px]">
                {newCompanyText}
              </p>
              {isEmpty(newCompanyItems) || (
                <div
                  className="flex flex-col md:flex-row gap-4 md:gap-6 2l:gap-[30px] w-full h-full
                mt-[10px] md:mt-5 lg:mt-0">
                  {map(newCompanyItems, (newCompanyItem, index) => (
                    <div
                      key={index}
                      className="md:w-1/2 bg-white h-full border-b-[2px]
                      border-b-[#CE445B] p-4 lg:p-6 2l:p-[30px] pb-[30px] flex flex-col gap-y-5
                      md:gap-y-[30px]">
                      <div className="flex flex-col gap-y-[10px] md:gap-y-[12px]">
                        <h4
                          className="text-clamp14to20 text-[#231F20] ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTCMedium
                        leading-1.375 2l:min-h-[56px]">
                          {newCompanyItem.content.authorityListTitle}
                        </h4>
                        <span
                          className="text-clamp12to14 uppercase ltr:tracking- [1.4px] ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight
                          text-[#333] 2l:min-h-[42px]">
                          {newCompanyItem.content.authorityListSubtitle}
                        </span>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: newCompanyItem.content.authorityListText,
                        }}
                        className="p-child:text-[#4D4D4D] p-child:text-clamp12to15
                        p-child:font-normal p-child:leading-1.4 p-child:mb-0
                        p-child:font-URWDINRegular flex flex-col gap-y-3 lg:gap-y-5"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div
              className="flex flex-col gap-y-[13px] lg:gap-y-[30px] lg:max-w-[570px]
            lg:items-center">
              <div
                className="flex flex-row lg:flex-col gap-x-[15px] md:gap-y-[30px]
              lg:items-center">
                <Sprites name="door" className="w-[20px] lg:w-[55px] h-[20px] lg:h-[55px] relative top-[-4px] lg:top-0" />
                <div className="flex flex-row gap-x-[15px]">
                  <Sprites name="left-down-arrow" className="mt-[9px] hidden lg:flex rtl:scale-x-[-1]" />
                  <span
                    className="text-clamp16to20 text-[#231F20] 
                    ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1
                    rtl:pt-[2px] rtl:md:pt-0
                    text-center">
                    {existingCompanyTitle}
                  </span>
                  <Sprites name="right-arrow-down" className="mt-[9px] hidden lg:flex rtl:scale-x-[-1]" />
                </div>
              </div>
              <p
                className="!m-0 text-clamp12to18 text-[#4D4D4D] leading-1.375 ltr:text-left
                rtl:text-right lg:!text-center ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight 
                lg:min-h-[65px] xl:min-h-[70px] 2xl:min-h-[75px]">
                {existingCompanyText}
              </p>
              {isEmpty(existingCompanyItems) || (
                <div
                  className="grid md:grid-cols-2 gap-4 md:gap-6 2l:gap-[30px] w-full h-full
                mt-[10px] md:mt-5 lg:mt-0">
                  {map(existingCompanyItems, (existingCompanyItem, index1) => (
                    <div
                      key={index1}
                      className=" bg-white h-full border-b-[2px]
                      border-b-[#CE445B] p-4 lg:p-6 2l:p-[30px] pb-[30px] flex flex-col gap-y-5
                      md:gap-y-[30px]">
                      <div className="flex flex-col gap-y-[10px] md:gap-y-[15px]">
                        <h4
                          className="text-clamp14to20 text-[#231F20] ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTCMedium
                        leading-1.375 2l:min-h-[56px]">
                          {existingCompanyItem.content.authorityListTitle}
                        </h4>
                        <span
                          className="text-clamp12to14 uppercase ltr:tracking- [1.4px] ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight
                          text-[#4D4D4D] 2l:min-h-[42px]">
                          {existingCompanyItem.content.authorityListSubtitle}
                        </span>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: existingCompanyItem.content.authorityListText,
                        }}
                        className="p-child:text-[#4D4D4D] p-child:text-clamp12to15
                        p-child:font-normal p-child:leading-1.4 p-child:mb-0
                        p-child:font-URWDINRegular flex flex-col gap-y-3 lg:gap-y-6"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </motion.div>
        </div>
      </BoxedContainer>
      {isEmpty(backgroundImage) || (
        <div className="absolute bottom-0 w-full lazy-load-image:!flex">
          <LazyLoadImage
            src={backgroundImage.url}
            width="100%"
            effect="blur"
            className="w-full h-full object-cover"
          />
        </div>
      )}
    </section>
  );
}
